import { CheckoutEnrollment } from '@spike/membership-model';
import { OrderItem, OrderizableTypes } from '@spike/order-model';
import capitalize from 'lodash/capitalize';
import { FunctionComponent } from 'react';
import Loader from './Loader';
import MembershipIcon from './MembershipIcon';
import NoneMembership from './NoneMembership';
import styles from './OrderItemMemberships.module.css';
import SelectedMembership from './SelectedMembership';
import SelectorMembership from './SelectorMembership';

export interface OrderItemMembershipsProps {
    orderItem: OrderItem;
    checkoutEnrollments: Array<CheckoutEnrollment>;
    saving?: boolean;
    onSelect?: (enrollmentId: number) => void;
    onDelete?: () => void;
    className?: string;
}

const getEnrollmentInfoRightElement = (
    enrollment: CheckoutEnrollment,
    classes: { container: string; icon: string; text: string }
): JSX.Element => {
    return (
        <div className={classes.container}>
            <MembershipIcon className={classes.icon} />
            <span className={classes.text}>{`${enrollment.items.left}/${enrollment.items.total}`}</span>
        </div>
    );
};

export const OrderItemMemberships: FunctionComponent<OrderItemMembershipsProps> = props => {
    const showOrderItemType = [OrderizableTypes.ADDON_SERVICE, OrderizableTypes.PRODUCT].includes(
        props.orderItem.orderizable.type
    );

    const orderItemType =
        props.orderItem.orderizable.type === OrderizableTypes.ADDON_SERVICE
            ? 'Add-On'
            : capitalize(props.orderItem.orderizable.type);

    const selectHandler = (optionId: number) => {
        props.onSelect && props.onSelect(optionId);
    };

    const deleteHandler = () => {
        props.onDelete && props.onDelete();
    };

    return (
        <div className={styles.container}>
            <p className={styles.title}>
                {props.orderItem.description} ({props.orderItem.quantity})
            </p>
            {showOrderItemType && <p className={styles.type}>{orderItemType}</p>}
            {props.orderItem.redeem !== undefined && (
                <SelectedMembership
                    name={props.orderItem.redeem.membership?.name ?? ''}
                    className={styles.selected}
                    saving={props.saving}
                    onDelete={deleteHandler}
                />
            )}
            {props.orderItem.redeem === undefined && props.checkoutEnrollments.length > 0 && props.saving && (
                <div className={styles.loaderContainer}>
                    <Loader
                        color="black"
                        size={5}
                        loading={props.saving}
                    />
                </div>
            )}
            {props.orderItem.redeem === undefined && props.checkoutEnrollments.length > 0 && !props.saving && (
                <SelectorMembership
                    orderItem={props.orderItem}
                    enrollments={props.checkoutEnrollments}
                    placeholder="Select a Membership"
                    className={styles.selector}
                    disabled={props.saving}
                    onSelect={selectHandler}
                />
            )}
            {props.orderItem.redeem === undefined && props.checkoutEnrollments.length === 0 && (
                <NoneMembership className={styles.selector} />
            )}
        </div>
    );
};

export default OrderItemMemberships;
